export const en = {
  title: 'DevTracker',
  nav: {
    overview: 'Overview',
    items: 'Requirements',
    gantt: 'Gantt',
    updates: 'Updates',
  },
  dashboard: {
    title: 'DevTracker Overview',
    subtitle: 'Track requirements, development, and testing in one view',
    gantt: 'Gantt Plan',
    requirements: 'Requirements',
    development: 'Development',
    testing: 'Testing',
    completed: 'Completed',
    viewAll: 'View All',
  },
  items: {
    title: 'Requirements',
    subtitle: '',
    createTitle: 'Create Requirement',
  },
  gantt: {
    title: 'Requirement Gantt',
    subtitle: 'View schedule and upcoming workload',
    dueAt: 'Est. Completion',
    days: 'd',
    toolbar: {
      view: 'View',
      today: 'Today',
      prev: 'Prev',
      next: 'Next',
    },
    views: {
      day: 'Day',
      week: 'Week',
      month: 'Month',
      quarter: 'Quarter',
      year: 'Year',
    },
    segments: {
      dev: 'Dev',
      test: 'Test',
    },
  },
  updates: {
    title: 'Release Notes',
    subtitle: 'Record version updates in one place',
    empty: 'No release notes yet',
    formTitle: 'New Release Note',
    fields: {
      version: 'Version',
      title: 'Title',
      releasedAt: 'Release Date',
      content: 'Details',
    },
    placeholders: {
      version: 'e.g. v1.2.0',
      title: 'Enter release note title',
    },
    actions: {
      create: 'Add Note',
      save: 'Save Note',
      cancel: 'Cancel',
    },
  },
  fields: {
    title: 'Title',
    description: 'Description',
    priority: 'Priority',
    moduleKey: 'Module',
    owner: 'Owner',
    itemType: 'Type',
    severity: 'Severity',
    parentId: 'Parent Module',
    labels: 'Labels',
  },
  status: {
    DRAFT: 'Proposed',
    REVIEWED: 'Reviewed',
    IN_DEVELOPMENT: 'In Development',
    IN_TESTING: 'In Testing',
    USER_TESTING: 'User Testing',
    DONE: 'Done',
    CANCELLED: 'Cancelled',
    ARCHIVED: 'Archived',
  },
  itemType: {
    MODULE: 'Module Requirement',
    FEATURE: 'Feature Requirement',
    BUG: 'Bug Requirement',
  },
  priority: {
    P0: 'P0 · Urgent',
    P1: 'P1 · High',
    P2: 'P2 · Medium',
    P3: 'P3 · Low',
  },
  filters: {
    keyword: 'Search keyword',
    status: 'Status',
    priority: 'Priority',
    itemType: 'Type',
    all: 'All',
  },
  table: {
    title: 'Title',
    type: 'Type',
    priority: 'Priority',
    status: 'Status',
    owner: 'Owner',
    updatedAt: 'Updated At',
    actions: 'Actions',
  },
  empty: {
    items: 'No requirements yet',
    gantt: 'No scheduled requirements',
    description: 'No description',
  },
  loading: 'Loading...',
  actions: {
    refresh: 'Refresh',
    createItem: 'Create Requirement',
    applyFilters: 'Apply Filters',
    selectOwner: 'Select Owner',
    cancel: 'Cancel',
    confirm: 'Confirm',
  },
  toast: {
    loadFailed: 'Failed to load data',
    createFailed: 'Failed to create item',
    releaseNoteCreateFailed: 'Failed to create release note',
    releaseNoteCreated: 'Release note created',
    updateFailed: 'Failed to update item',
    created: 'Created successfully',
    statusUpdated: 'Status updated',
    requiredFields: 'Please fill required fields',
    contentRequired: 'Please enter requirement details',
  },
  detail: {
    section: 'Requirement Details',
    metaTitle: 'Key Info',
    stageTitle: 'Stage Timeline',
    documentTitle: 'Requirement Document',
    save: 'Save Document',
    saving: 'Saving...',
    contentPlaceholder: 'Describe background, scope, and acceptance criteria...',
    groups: {
      progress: 'Progress',
      people: 'People',
      timeline: 'Timeline',
    },
    timeline: {
      edit: 'Adjust',
      set: 'Set',
      save: 'Save',
      cancel: 'Cancel',
    },
    labels: {
      code: 'Code',
      status: 'Status',
      priority: 'Priority',
      moduleKey: 'Module Key',
      owner: 'Owner',
      reporter: 'Reporter',
      reviewer: 'Reviewer',
      createdAt: 'Proposed At',
      reviewedAt: 'Reviewed At',
      startAt: 'Start At',
      devEtaAt: 'Dev ETA',
      devCompletedAt: 'Dev Completed At',
      testEtaAt: 'Test ETA',
      testCompletedAt: 'Test Completed At',
      etaAt: 'ETA',
      completedAt: 'Completed At',
    },
    actions: {
      REVIEWED: 'Confirm Review',
      IN_DEVELOPMENT: 'Move to Development',
      IN_TESTING: 'Move to Testing',
      USER_TESTING: 'Move to User Testing',
      DONE: 'Mark as Done',
      ARCHIVED: 'Archive',
      CANCELLED: 'Cancel Requirement',
    },
  },
  create: {
    title: 'Create Requirement',
    back: 'Back to Requirements',
    submit: 'Submit Requirement',
    centerTitle: 'Create Requirement',
    defaultTitle: 'Untitled Requirement',
    titlePlaceholder: 'Enter requirement title',
    titleRequired: 'Please enter a requirement title',
    contentHint: 'Please enter a detailed description',
    contentPlaceholder: 'Describe background, scope, and acceptance criteria...',
    saving: 'Creating...',
    modulePlaceholder: 'Select parent module',
    moduleEmpty: 'No module requirements available',
    moduleKeyPlaceholder: 'Enter module name (English only)',
    ownerTitle: 'Select Owner',
  },
};
